<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/approval-widget/approval-widget.component.ts
-->
<ng-template #anchor></ng-template>
